export const eventListeners = {
  addCoverage: 'JQ_REACT_ADD_COVERAGE',
  deleteCoverage: 'JQ_REACT_DELETE_COVERAGE'
}

export const connectEventToState = {
  create: (eventListenerName: string, element: HTMLElement, callback: EventListenerOrEventListenerObject): Event => {
    // should cover most old browsers
    let event = document.createEvent('Event');

    if (eventListenerName && element) {
      event.initEvent(eventListenerName, true, true);
      element.addEventListener(eventListenerName, callback, false);
      return event;
    }

    return event;
  }
} 